module.exports = "# Sizzle\n\n## Content\n\n### Activity: Make a Skit!\n\n## Notes\nActivity: Make a Skit\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* In this skit, you and a few friends are enjoying a water activity, when you notice someone hurting water.\n* In a kind way, convince that person to be a Planet Protector and to protect water.\n* Practice the skit as a team (10 min) and then perform for your class!\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level4_skit.md
// module id = 1704
// module chunks = 2